import * as React from "react";
import {t} from "i18next";
import {Label} from "semantic-ui-react";

import {KumaViewDto} from "src/services/Client";
import {Dialog} from "../../components/Dialogs/Dialog";
import {Button} from "../../components/Button";

interface IKumaDeleteConfirmDialogProps {
    canDeleteDtos: KumaViewDto[];
    onConfirm(): void;
    onCancel(): void;
}

export const KumaDeleteConfirmDialog = (props: IKumaDeleteConfirmDialogProps) => {

    return (
        <Dialog
            title={t("KUMA_VIEW:DELETE_REQUIREMENT")}
            customStyleClassName={"scrollableYDialog"}
            open={true}
            actions={
                [
                    props.canDeleteDtos.length > 0 ?
                        <Button
                            key={"submit"}
                            icon={"checkmark"}
                            label={t("GLOBAL:CONFIRM")}
                            onClick={props.onConfirm}
                        /> : <></>,
                    <Button
                        key={"cancel"}
                        icon={"ban"}
                        label={t("GLOBAL:CANCEL")}
                        onClick={props.onCancel}
                    />
                ]
            }
        >
            <p>{t("KUMA_VIEW:CONFIRM_DELETE_TEXT")}</p>
            <p><b>{props.canDeleteDtos.length}</b> {' ' + t("KUMA_VIEW:KUMA_REQUIREMENT_SELECTED")}</p>
            {props.canDeleteDtos.length > 0 &&
                <>
                    <p><b>{t("KUMA_VIEW:AVAILABLE_FOR_DELETE")}</b></p>
                    {props.canDeleteDtos.map((dto: KumaViewDto, index: number) => {
                        return (
                            <Label
                                key={"tag-av" + index}
                                tag={true}
                                color={"blue"}
                                style={{ "marginRight": "10px", "marginBottom": "5px" }}
                            >
                                {dto.objectId.toString().concat('-', dto.title ? dto.title : '')}
                            </Label>
                        );
                    })}
                </>
            }
        </Dialog>
    );
};



// WEBPACK FOOTER //
// ./src/views/KumaView/KumaDeleteConfirmDialog.tsx